import { RegionShared } from "@1games-ru/region-shared";
import { useCallback, useState } from "react";
import { callServer } from "@/core/helpers/callEvent.ts";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useErrorTranslation from "@/core/helpers/useErrorTranslation";

const useSignInPin = () => {
  const tError = useErrorTranslation();
  const dispatch = useAppDispatch();
  const [pending, setPending] = useState<boolean>(false);
  const [error, setError] = useState<string | undefined>();
  const [completed, setCompleted] = useState(false);

  const onSubmit = useCallback(
    async (password: string) => {
      try {
        setError("");
        setPending(true);

        await callServer(RegionShared.Backend.Events.Auth.StartSession, {
          code: password,
        });

        setCompleted(true);
        // eslint-disable-next-line
      } catch (err: any) {
        const message = err?.message || "Unknown error";
        setError(tError(message));
        throw err;
      } finally {
        setPending(false);
      }
    },
    [dispatch],
  );

  return {
    pending,
    error,
    onSubmit,
    setError,
    completed,
    setCompleted,
  };
};

export default useSignInPin;
